import { StudyDataType } from "@/types/apiTypes";
import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const fetchStudiesApi = async (
  studySearchTerm: string,
  selectedProjectId: string | null,
): Promise<StudyDataType[]> => {
  const token = await getToken();
  if (!token) {
    throw new Error("Authorization token is required");
  }

  try {
    const response = await axios.post<StudyDataType[]>(
      `${API_BASE_URL}/general-search`,
      {
        search_term: studySearchTerm || "",
        search_type: "studies",
        project_id: selectedProjectId || null,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch studies", error);
    throw error;
  }
};
